module.exports = __webpack_public_path__ + "9f2fcc1e3cc56ff5a62e7a0d7bb7f300.svg";